export default __webpack_public_path__ + "static/media/delivered.7d9f793d.png";